// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","869":"styles"}[chunkId] + "-" + {"245":"485318a5cf8267e7fbb4","453":"1d6a8f168697f7cedf8f","869":"2e36ded583e4e5798bbe"}[chunkId] + ".js";
};